import {
  ButtonWithTooltip,
  iconComponentFor$,
  openLinkEditDialog$,
  useCellValues,
  usePublisher,
} from "@mdxeditor/editor";
import React from "react";

export const LinkButton = () => {
  const openLinkDialog = usePublisher(openLinkEditDialog$);
  const [iconComponentFor] = useCellValues(iconComponentFor$);

  return (
    <ButtonWithTooltip
      title="Link"
      onClick={() => {
        openLinkDialog();
      }}
      className="hover:bg-surface-hovered w-6 h-6 flex items-center justify-center cursor-pointer rounded-sm"
    >
      {iconComponentFor("link")}
    </ButtonWithTooltip>
  );
};

export default LinkButton;
